import React from "react";
import { FormatDateOptions, FormattedMessage, useIntl } from "react-intl";

import { Tooltip } from "src/common/components/Tooltip";
import { useFormatName } from "src/common/hooks/useFormatName";
import { useKnownUsers } from "src/features/auth";
import { PatientLink } from "src/features/patient";
import { useAbdominalPelvisUltrasound } from "src/modules/ktx/header/hooks/useAbdominalPelvisUltrasound";
import { messages as ktxHeaderMessages } from "src/modules/ktx/header/messages";
import { HeaderValue, renderTitle } from "src/modules/shared/header";

import "./Header.css";

const formatDateOptions: FormatDateOptions = {
	year: "numeric",
	month: "numeric",
	day: "numeric"
};

export const AbdominalPelvisUltrasound: React.FunctionComponent = () => {
	const users = useKnownUsers();

	const { value, timestamp, origin } = useAbdominalPelvisUltrasound();
	const { formatDate } = useIntl();
	const formatName = useFormatName();

	let extra;
	if (timestamp) {
		extra = value;
	}

	const title = renderTitle({
		users,
		timestamp,
		origin,
		extra,
		formatDate,
		formatName
	});

	let content = (
		<>
			<FormattedMessage
				{...ktxHeaderMessages.abdominalPelvisUltrasound}
			/>
			{": "}
			{timestamp ? formatDate(timestamp, formatDateOptions) : "-"}
		</>
	);

	if (origin !== undefined) {
		content = (
			<PatientLink to={`/form/${origin.kind}/${origin.id}`}>
				{content}
			</PatientLink>
		);
	}

	return (
		<Tooltip
			title={title}
			content={<HeaderValue variant="a_p_u">{content}</HeaderValue>}
		/>
	);
};
